import request from '@/utils/request'

//出入库变更
export function crkbgList(type, ywid, data) {
  return request({
    method: 'post',
    url: `/yzdservice/api/enterprise/crkBgjlList/${type}/${ywid}`,
    data: data
  })
}

//出入库变更 详情页面数据获取
export function crkbgXqData(bgjlId) {
  return request({
    method: 'get',
    url: `/yzdservice/api/enterprise/crkBgjlDetail/${bgjlId}`
  })
}

//移库报备变更列表
export function ykbbbgList(type, ywid, data) {
  return request({
    method: 'post',
    url: `/yzdservice/api/enterprise/ykbb/crkBgjlList/${ywid}`,
    data: data
  })
}
//移库报备变更 详情页面数据获取
export function ykbbbgXqData(bgjlId) {
  return request({
    method: 'get',
    url: `/yzdservice/api/enterprise/ykbb/crkBgjlDetail/${bgjlId}`
  })
}
//运输报备变更列表
export function ysbbbgList(type, ywid, data) {
  return request({
    method: 'post',
    url: `/yzdservice/api/enterprise/ysbb/crkBgjlList/${ywid}`,
    data: data
  })
}
//运输报备 详情页面数据获取
export function ysbbbgXqData(bgjlId) {
  return request({
    method: 'get',
    url: `/yzdservice/api/enterprise/ysbb/crkBgjlDetail/${bgjlId}`
  })
}

